<template>
    <div :class="['tab-content tab-content-desktop-' + desktop + ' tab-content-mobile-' + mobile + ' ' + activeClass]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'CustomTabContent',
        props: ['desktop', 'mobile', 'tab'],
        computed: {
            activeClass(){
                return  (this.tab.active === true ? 'active' : '' );
            }
        },
    }
</script>

<style scoped>
    .tab-content {
        display: none !important;
    }

    .tab-content.active {
        display: inline-block !important;
    }

    .tab-content ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .tab-content li {
        list-style-type: none;
        text-align: center;
        float: left;
        border-right: 1px solid #595B5E;
        padding: 0 16px;
        margin-left: 0;
        margin-bottom: 0;
    }

    .tab-content li:first-of-type {
        padding-left: 5px;
    }

    @media only screen and (max-width: 767px) {
        .tab-content-mobile- li,
        .tab-content-mobile-default li{
            width: 100%;
            border-right: 0;
            border-bottom: 1px solid #595B5E;
            padding: 10px 0;
        }
    }
    @media only screen and (min-width: 768px) {
        .tab-content-desktop-,
        .tab-content-desktop-default {
            display: inline-block;
            margin-bottom: 0;
            background-color: #3E4143;
            width: 100%;
            border: 0 !important;
            min-height: 35px;
            padding-top: 20px;
            padding-left: 12px;
            padding-bottom: 20px;
        }

        .tab-content-item-desktop- a,
        .tab-content-item-desktop-default a{
            color: white
        }
    }
</style>